export function buildClient(basePath, serviceUris) {
    var clientUris = {};
    for (var _i = 0, _a = Object.entries(serviceUris); _i < _a.length; _i++) {
        var _b = _a[_i], key = _b[0], value = _b[1];
        clientUris[key] = "/".concat(basePath).concat(value);
    }
    return clientUris;
}
//# sourceMappingURL=url.js.map